<template>
  <div>
    <div class="content-box">
      <GraficoModalComponent
        v-if="current.id"
        :id="current.id"
        :modulo="inv"
        :path="'ent_compra'"
      />
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">
                  Entrada por Compra #
                  <u>{{ current.numero }}</u>
                  &nbsp;
                  <div
                    class="badge"
                    :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                    }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">
                      {{ current.estado_str }}
                    </span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                </h5>
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <button
                      :disabled="current.estado == 'A'"
                      class="btn btn-outline-dark"
                      @click="imprimir"
                    >
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button
                        :disabled="!(current.estado == 'B')"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-print"></i>
                        Etiquetas
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" @click="imprimir_barra">Barras</a>
                        <a class="dropdown-item" @click="imprimir_hablador">Habladores</a>
                      </div>
                    </div>
                    &nbsp;
                    <div class="btn-group">
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          :class="{ disabled: !(current.estado == 'B') }"
                          @click="abrir"
                          :disabled="!(current.estado == 'B')"
                          href="#"
                        >
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="cerrar"
                          :disabled="!(current.estado == 'A')"
                          href="#"
                        >
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="anular"
                          :disabled="!(current.estado != '9')"
                          href="#"
                        >
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                  <div class="element-actions"></div>
                </div>
                <small
                  v-if="current.errors && current.errors.detail"
                  class="form-text text-danger"
                  >{{ current.errors.detail }}</small
                >
                <br />
                <br />
                <br />
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.tienda,
                        }"
                        >Tienda</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tienda"
                        :disabled="current.estado != 'A'"
                      >
                        <option
                          v-for="(tienda, key) in tiendas"
                          :value="tienda.codigo"
                          :key="key"
                        >
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tienda"
                        class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <ProveedoresSelectComponent
                      :current="current"
                      :disabled="current.estado != 'A'"
                    />
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label>Fecha</label>
                      <input
                        v-model="current.fecha"
                        class="form-control"
                        placeholder="Fecha"
                        :disabled="true"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input
                        :disabled="true"
                        class="form-control"
                        v-model="current.usuario"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <h6 v-if="factura">
                  Generada desde la factura: #
                  <router-link
                    :to="{
                      name: 'compras-factura-editar',
                      params: { id: factura.id },
                    }"
                    class="text-success"
                    >{{ factura.documento }}</router-link
                  >
                </h6>
                <br />
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Producto</th>
                        <th class="text-center">Cantidad ingresada</th>
                        <th class="text-center">Cantidad pendiente por orden compra</th>
                        <th class="text-center">Lote</th>
                        <th class="text-center">Posicion</th>
                        <th class="text-center nowrap">Estado</th>
                        <th v-if="current.estado == 'A'" class="text-center">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.entradaporcomprad_set"
                        v-bind:key="detalle.id"
                      >
                        <td>
                          <span>{{ detalle.producto.sku }}</span>
                        </td>
                        <td>{{ detalle.producto.nombre }}</td>
                        <td class="text-center bolder nowrap" style="font-weight: 500">
                          <span class="text-success">+ {{ detalle.cantidad }}</span>
                        </td>
                        <td class="text-center bolder nowrap" style="font-weight: 500">
                          <span v-if="detalle.orden_compra_d" class="text-danger">{{
                            detalle.orden_compra_d.pendiente
                          }}</span>
                        </td>
                        <td class="text-center bolder nowrap" style="font-weight: 500">
                          <span v-if="detalle.producto_lote">{{
                            detalle.producto_lote.codigo_lote
                          }}</span>
                        </td>
                        <td class="text-center bolder nowrap" style="font-weight: 500">
                          <span>{{ detalle.posicion }}</span>
                        </td>
                        <td class="text-center">
                          <span
                            class="status-pill smaller green"
                            v-if="detalle.estado == 'A'"
                          ></span>
                          <span
                            class="status-pill smaller red"
                            v-if="detalle.estado == 'B'"
                          ></span>
                        </td>
                        <td
                          v-if="detalle.estado == 'A' && current.estado == 'A'"
                          class="text-center"
                          style="width: 200px"
                        >
                          <button
                            type="button"
                            class="btn btn-sm btn-secondary"
                            @click="showModalModDetail(detalle)"
                            v-if="current.estado == 'A'"
                          >
                            <i class="fa fa-edit"></i>
                            Editar
                          </button>
                          <button
                            class="btn btn-sm btn-danger mr-1"
                            type="button"
                            @click="eliminarDetalle(detalle)"
                          >
                            <i class="fa fa-trash"></i>
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="showModalAddDetail"
                      v-if="current.estado == 'A'"
                    >
                      <i class="fa fa-plus"></i>
                      Agregar Productos
                    </button>
                  </div>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <div class="form-buttons-w">
                  <button
                    class="btn btn-md btn-success"
                    v-if="current.estado == 'A'"
                    type="submit"
                  >
                    Guardar
                  </button>
                  <router-link
                    class="btn btn-outline-info"
                    :to="{ name: 'inventario-entrada_compra' }"
                  >
                    <i class="fa fa-arrow-left"></i>
                    Listado de Entradas
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalModDetailEntradaCompra"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Modificar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Producto</label>
                    <input
                      v-model="currentDetalleMod.producto.sku"
                      class="form-control"
                      placeholder="Producto"
                      readonly="readonly"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Cantidad en Unidades</label>
                    <input
                      v-model="currentDetalleMod.cantidad"
                      class="form-control"
                      placeholder="Cantidad Unidades"
                      type="text"
                      style="text-align: center; font-size: 200%"
                    />
                    <small
                      v-if="currentDetalleMod.errors && currentDetalleMod.errors.cantidad"
                      class="form-text text-danger"
                      >{{ currentDetalleMod.errors.cantidad[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Tarima</label>
                    <input
                      v-model="currentDetalleMod.tarima"
                      class="form-control"
                      placeholder="Tarima"
                      type="text"
                      style="text-align: center; font-size: 200%"
                    />
                    <small
                      v-if="currentDetalleMod.errors && currentDetalleMod.errors.tarima"
                      class="form-text text-danger"
                      >{{ currentDetalleMod.errors.tarima }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Lote</label>
                    <select
                      v-if="currentDetalleMod.productolote_set"
                      v-model="currentDetalleMod.producto_lote"
                      class="form-control"
                      autofocus="autofocus"
                    >
                      <option
                        v-for="detalle in currentDetalleMod.productolote_set"
                        :value="detalle"
                        v-bind:key="detalle.id"
                      >
                        Lote: {{ detalle.codigo_lote }} || Vence:
                        {{ detalle.fecha_vence }}
                      </option>
                    </select>
                    <small
                      v-if="
                        currentDetalleMod.errors && currentDetalleMod.errors.producto_lote
                      "
                      class="form-text text-danger"
                      >{{ currentDetalleMod.errors.producto_lote[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Posicion</label>

                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalleMod.posicion"
                    >
                      <option
                        v-for="(detalle, key) in posiciones"
                        :value="detalle.posicion_id"
                        :key="key"
                      >
                        {{ detalle.codigo_barra }}
                      </option>
                    </select>
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.posicion"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.posicion }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="modificarDetalle" type="button">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetailReqCompra"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div class="row">
                <div class="col-12">
                  <ProductoSelectComponent :current="currentDetalle" />
                </div>
                <div class="col-sm-12">
                  Lotes:
                  <select
                    v-model="currentDetalle.codigo_lote"
                    v-if="
                      currentDetalle.productolote_set != null &&
                      currentDetalle.productolote_set.length > 0
                    "
                    class="form-control"
                    autofocus="autofocus"
                  >
                    <option
                      v-for="detalle in currentDetalle.productolote_set"
                      :value="detalle.id"
                      v-bind:key="detalle.id"
                    >
                      Lote: {{ detalle.codigo_lote }} || Vence:
                      {{ detalle.fecha_vence }}
                    </option>
                  </select>
                  <small
                    v-if="currentDetalle.errors && currentDetalle.errors.producto_lote"
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.producto_lote }}</small
                  >
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                      >Cantidad en Unidades</label
                    >
                    <input
                      v-model="currentDetalle.cantidad"
                      class="form-control"
                      placeholder="cantidad"
                      type="text"
                      style="text-align: center; font-size: 200%"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                    />
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.cantidad"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.cantidad }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Tarima</label>
                    <input
                      v-model="currentDetalle.tarima"
                      class="form-control"
                      placeholder="Tarima"
                      type="text"
                      style="text-align: center; font-size: 200%"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Posicion</label>

                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalle.posicion"
                    >
                      <option
                        v-for="(detalle, key) in posiciones"
                        :value="detalle.posicion_id"
                        :key="key"
                      >
                        {{ detalle.codigo_barra }}
                      </option>
                    </select>
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.posicion"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.posicion }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregar_detalle" type="button">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal1"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAdddevolucion"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Devoluciones a Clientes</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.caja,
                      }"
                      >Caja</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalle.caja"
                      @change="refreshCaja"
                      @input="$emit('input', $event.target.value)"
                    >
                      <option v-for="(c, key) in caja" :value="c.id" :key="key">
                        Caja: {{ c.caja }} - Tienda {{ c.tienda.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.caja"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.caja }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Observación</label>
                    <textarea
                      v-model="currentDetalle.observacion"
                      class="form-control"
                      type="text"
                    />
                    <small
                      v-if="currentDetalle.errors && currentDetalle.errors.observacion"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.observacion[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="guardarDevolucion" type="button">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModalDetalle"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import EntradaCompraService from "@/services/inventario/EntradaCompraService";
import OrdenCompraService from "@/services/compras/OrdenCompraService";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import Notifications from "@/notifications/notifications";
import DevolucionesProveedoresService from "@/services/inventario/DevolucionesProveedoresService";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import GraficoModalComponent from "@/components/commons/GraficoModalComponent";

var name = "John Smith";
$("#name").text(name);
export default {
  components: {
    ProveedoresSelectComponent,
    ProductoSelectComponent,
    GraficoModalComponent,
  },
  data() {
    return {
      isOpen: false,
      testVal: null,
      current: {
        id: null,
        estado_str: null,
        tienda: null,
        fecha: "01/01/2019",
        estado: "A",
        proveedor: null,
        usuario: "",
        entradaporcomprad_set: "",
        errors: {
          proveedor: "",
        },
      },
      posiciones: "",
      productos: [],
      orden_compra_e: [],
      proveedores: [],
      options: [],
      producto_lote: [],

      currentDetalleMod: {
        id: null,
        cantidad: 0,
        precio_unitario: 0.0,
        producto: [],
        tarima: "",
        producto_lote: [],
        posicion: "",
        posicion_id: "",
        errors: [],
      },
      codigo_barra: [],
      factura: "",
      currentDetalle: {
        cantidad: 0,
        posicion: 0,
        tarima: 0,
        impr: 0,
        posicion: "",
        productolote_set: [],
        ordencomprad_set: [],
        codigo_lote: 0,
        producto: "",
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      caja: "cargos/caja",
    }),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
  },
  created() {
    this.current.usuario = localStorage.getItem("id_usuario");
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
      self.formatoFecha();
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
    this.refreshData();
    self.addProveedor();
  },
  methods: {
    refreshFactura() {
      DynamicService.fetch("wms", "facturas", {
        entrada_por_compra_e: this.current.id,
      }).then((response) => {
        this.factura = response.data.results[0];
      });
    },
    refreshCaja() {
      let self = this;
      self.$store.dispatch("cargos/caja", {
        activa: true,
        quitar_paginacion: true,
      });
    },

    rowClick() {
      let self = this;
      self.refreshCaja();
      $("#modalAdddevolucion").modal();
    },

    guardarDevolucion() {
      let self = this;
      let currentDetalle = Object.assign({}, self.currentDetalle);
      currentDetalle.cargo_id = self.current.id;
      console.log(currentDetalle);
      DevolucionesProveedoresService.save(currentDetalle)
        .then((response) => {
          self.$refs.cerrarModalDetalle.click();
          self.$router.push({
            name: "inventario-devoluciones-editar",
            params: { id: response.data.id },
          });
          self.refreshCurrent();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          if (self.current.errors.devolucion_cliente) {
            Notifications.alert.error("Error", self.current.errors.devolucion_cliente);
          }
        });
    },

    rowClick(current) {
      let self = this;
      self.current.cargo_id = current.id;
      self.refreshCaja();
      $("#modalAdddevolucion").modal();
    },

    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    imprimir_barra() {
      let self = this;
      EntradaCompraService.imprimir_barra(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },

    imprimir_hablador() {
      let self = this;
      EntradaCompraService.imprimir_hablador(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    refreshData() {
      let self = this;
      self.$store.dispatch("catalogos/posicion", {
        activa: true,

        quitar_paginacion: true,
      });
    },
    llenarLote(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
        if (res.data.productolote_set.length == 0) {
          alert("El producto no tiene lotes definidos");
        } else {
          self.currentDetalle.codigo_lote = res.data.productolote_set[0].id;
        }
      });
    },
    llenarCompra(value) {
      let self = this;
      OrdenCompraService.getById(value.id).then((res) => {
        self.currentDetalle.ordencomprad_set = res.data.ordencomprad_set;
      });
    },
    onSearchPosicion(search, loading) {
      loading(true);
      this.searchPosicion(loading, search, this);
    },

    searchPosicion: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);

        return;
      }
      let that = this;

      PosicionesService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.codigo_barra = res.data;
        loading(false);
      });
    }, 350),

    refreshCurrent() {
      let self = this;
      EntradaCompraService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda = response.data.tienda.codigo;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.refreshFactura();
      });
    },
    toggleBtn: function () {
      this.isOpen = !this.isOpen;
      self.refreshCurrent();
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      self.formatoFecha();
      let current = Object.assign({}, self.current);
      if (current.proveedor != null) {
        current.proveedor = current.proveedor.id;
      }
      EntradaCompraService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "inventario-entrada_compra-editar",
              params: {
                id: response.data.id,
              },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),

    searchProveedor: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProveedorService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.proveedores = res.data;
        loading(false);
      });
    }, 350),
    onSearchProveedor(search, loading) {
      loading(true);
      this.search(loading, searchProveedor, this);
    },

    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        self.llenarLote(self.productos[0]);
      });
      PosicionesService.fetch({
        tienda: self.current.tienda,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      OrdenCompraService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.orden_compra_e = res.data.results;
        self.llenarCompra(self.orden_compra_e[0]);
      });
      this.currentDetalle.tienda = this.current.tienda;
      $("#modalAddDetailReqCompra").modal();
    },

    addProveedor() {
      let self = this;
      ProveedorService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.proveedores = res.data.results;
      });
    },

    agregaProveedor() {
      self.refreshCurrent();
      this.$modal.hide("dialog");
    },

    showModalModDetail(detalle) {
      let self = this;
      ProductosService.getById(detalle.producto.sku).then((res) => {
        self.currentDetalleMod.productolote_set = res.data.productolote_set;
        self.currentDetalleMod.tarima = detalle.tarima;
        self.currentDetalleMod.posicion = detalle.posicion;
        self.currentDetalleMod.cantidad = detalle.cantidad;
        self.currentDetalleMod.producto_lote = detalle.producto_lote;
        self.currentDetalleMod.id = detalle.id;
        self.currentDetalleMod.producto = detalle.producto;
      });
      PosicionesService.fetch({
        tienda: self.current.tienda,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalModDetailEntradaCompra").modal();
    },

    modificarDetalle() {
      let self = this;
      let detMod = Object.assign({}, self.currentDetalleMod);
      if (detMod.posicion != null) {
        if (detMod.posicion.posicion_id) {
          detMod.posicion = detMod.posicion.posicion_id;
        }
      }
      detMod.producto_lote = detMod.producto_lote.id;
      detMod.id = detMod.id;
      detMod.cantidad = detMod.cantidad;
      detMod.tarima = detMod.tarima;
      EntradaCompraService.editarDetalle(self.current.id, detMod)
        .then((response) => {
          Notifications.alert.success(
            "Entrada por Compra",
            "Se ha Modificado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleModDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          self.currentDetalleMod.errors = error.response.data;
        });
    },

    agregar_detalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (det.codigo_lote) {
        det.producto_lote = det.codigo_lote;
      }
      EntradaCompraService.agregar_detalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Entrada por Compra",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal1.click();
        })
        .catch((error) => {
          error.response.data;
          self.currentDetalle.errors = error.response.data;
          if (self.currentDetalle.errors.detail) {
            Notifications.alert.error("Entrada por Compra", error.response.data.detail);
          }
        });
    },

    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Compra",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          EntradaCompraService.eliminarDetalle(detalle.entrada_por_compra_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Compra",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Compra",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          EntradaCompraService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Compra",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Compra",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          EntradaCompraService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Compra",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Entrada por Compra",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          EntradaCompraService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Entrada por Compra",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    onChangeProducto(producto) {
      let self = this;
      self.llenarLote(self.currentDetalle.producto);
    },
    onChangeCompra(Compra) {
      let self = this;
      self.llenarCompra(compra);
    },
    refreshDetalleModDefault() {
      let self = this;
      self.currentDetalleMod = {
        cantidad: "",
        cantidad_um: "",
        posicion: "",
        producto: {
          errors: [],
        },
        errors: [],
      };
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    imprimir() {
      let self = this;
      EntradaCompraService.pdf(self.current.id)
        .then((response) => {
          console.log(response.data.output);
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
